import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import {
  Box,
  Grid,
  Modal,
  TextareaAutosize,
  TextField
} from '@material-ui/core';
import {
  ModalCancelButton,
  ModalDeleteButton,
  ModalSubmitButton
} from './style/style';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AppTextfield } from '../input/AppTextfield';
import { emailValidation } from '../../../const/Const';
import { SelectIcon } from './SelectIcon';
import { sendDocument } from '../../../apicalls/estimates';

type Tprops = {
  openAlertModal: boolean;
  setOpenAlertModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleCopyStateMessage: any;
  clientName: any;
  setClientName: any;
  clientEmail: any;
  setClientEmail: any;
  clientCompanyName: any;
  setClientCompanyName: any;
  documentId: any;
  documentName: any;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const isMobile = window.innerWidth < 500;

export const AlertModal: React.FC<Tprops> = (props: Tprops) => {
  const {
    openAlertModal,
    setOpenAlertModal,
    handleCopyStateMessage,
    clientName,
    setClientName,
    clientEmail,
    setClientEmail,
    clientCompanyName,
    setClientCompanyName,
    documentId,
    documentName,
    setErrorMessage,
    setOpen
  } = props;

  const [message, setMessage] = useState('');

  const classes = useStyles();
  const sendEmail = () => {
    // 入力バリデーション
    if (!clientName || clientName.trim() === '') {
      setErrorMessage('宛名を入力してください。');
      setOpen(true);
      return;
    }
    if (!clientEmail || clientEmail.trim() === '') {
      setErrorMessage('メールアドレスを入力してください。');
      setOpen(true);
      return;
    }
    if (!emailValidation.test(clientEmail)) {
      setErrorMessage('有効なメールアドレスを入力してください。');
      setOpen(true);
      return;
    }
    if (!clientCompanyName || clientCompanyName.trim() === '') {
      setErrorMessage('会社名を入力してください。');
      setOpen(true);
      return;
    }

    // メール送信処理
    sendDocument(
      clientEmail,
      clientCompanyName,
      clientName,
      documentId,
      message
    ).then(async data => {
      if (typeof data === 'string') {
        setErrorMessage(data);
        setOpen(true);
      } else {
        if (data.error) {
          setErrorMessage(data.error);
          setOpen(true);
        } else {
          handleCopyStateMessage(data.message);
          setOpenAlertModal(false); // 送信成功時にモーダルを閉じる
          handleClose();
        }
      }
    });
  };

  const handleClose = () => {
    setOpenAlertModal(false);
    setClientName('');
    setClientEmail('');
    setClientCompanyName('');
    setMessage('');
  };

  return (
    <Modal
      open={openAlertModal}
      onClose={handleClose}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.modalHeader}>
          <h1 className={classes.modalTitle}>メールを送信</h1>
        </Grid>
        <Grid xs={12} className={classes.modalBody}>
          <Grid item xs={12}>
            <div className={classes.item}>
              <div style={{ minWidth: '120px', marginRight: '10px' }}>
                書類名
              </div>
              <SelectIcon
                width={31}
                height={38}
                format={'application/pdf'}
                name={'sample.pdf'}
              />
              <div
                style={{
                  width: '100%',
                  wordBreak: 'break-all',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {documentName ? `${documentName}.pdf` : ''}
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.item}>
              <div style={{ minWidth: '120px', marginRight: '10px' }}>
                宛名<span>*</span>
              </div>
              <TextField
                id='outlined-basic'
                variant='outlined'
                size='small'
                fullWidth
                margin='normal'
                value={clientName ? clientName : ''}
                onChange={e => {
                  setClientName(e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.item}>
              <div style={{ minWidth: '120px', marginRight: '10px' }}>
                メールアドレス<span>*</span>
              </div>
              <TextField
                id='outlined-basic'
                variant='outlined'
                size='small'
                fullWidth
                margin='normal'
                value={clientEmail ? clientEmail : ''}
                onChange={e => {
                  setClientEmail(e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.item}>
              <div style={{ minWidth: '120px', marginRight: '10px' }}>
                会社名<span>*</span>
              </div>
              <TextField
                id='outlined-basic'
                variant='outlined'
                size='small'
                fullWidth
                margin='normal'
                value={clientCompanyName ? clientCompanyName : ''}
                onChange={e => {
                  setClientCompanyName(e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.item}>
              <div style={{ minWidth: '120px', marginRight: '10px' }}>
                メッセージ
              </div>
              <TextField
                name={'name'}
                style={{ width: '100%', marginTop: '16px' }}
                multiline={true}
                variant='outlined'
                rows={3}
                onChange={e => {
                  setMessage(e.target.value);
                }}
              />
            </div>
          </Grid>
        </Grid>
        {/* モーダル下部 */}
        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton variant='contained' onClick={handleClose}>
            キャンセル
          </ModalCancelButton>
          <ModalSubmitButton
            variant='contained'
            onClick={() => {
              sendEmail();
            }}
          >
            送信する
          </ModalSubmitButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1)
      }
    },
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: isMobile ? '80%' : '50%',
      height: isMobile ? '70%' : '',
      overflow: 'scroll'
    },
    modalHeader: {
      width: '100%',
      textAlign: 'center',
      paddingBottom: 24,
      borderBottom: '1px solid #cfcfcf'
    },
    modalTitle: {
      // モーダル上部
      fontWeight: 'bold',
      marginTop: 32,
      marginBottom: 20,
      fontSize: 16
    },
    modalBody: {
      padding: 30
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: isMobile ? 15 : 30
    },
    item: {
      // 各項目のフォーム
      display: 'flex',
      width: '100%',
      alignItems: isMobile ? 'start' : 'center',
      flexDirection: isMobile ? 'column' : 'row'
    }
  })
);
